import { TOrganizationResponse, TOrganizationResponsePaginated } from 'app/services/edpApiV1/moderator';
import { TableRowSelection } from 'antd/lib/table/interface';
import { Input, Pagination, Spin, Table } from 'antd';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { TOrgDivResponse } from 'shared/types/poll.types';
import style from './index.module.scss';

type TOrganizationsSearchProps = {
  selectedOrganizations?: TOrganizationResponse[];
  addOrganizations: (users: TOrganizationResponse[]) => void;
  getOrganizationsQuery: (...args: any[]) => void;
  data?: TOrganizationResponsePaginated | TOrgDivResponse;
  isFetching?: boolean;
  isActive?: boolean;
};

const columns = [
  {
    title: 'Наименование',
    dataIndex: 'name',
    key: 'name',
  },
];

const OrganizationsSearch: FC<TOrganizationsSearchProps> = ({
  addOrganizations,
  selectedOrganizations,
  getOrganizationsQuery,
  data,
  isFetching,
  isActive,
}) => {
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [searchField, setSearchField] = useState<string>('');
  const [search, setSearch] = useState<string>('');

  useEffect(() => {
    getOrganizationsQuery({ search: searchField, page, size });
  }, []);

  useEffect(() => {
    getOrganizationsQuery({ search: searchField, page, size });
  }, [searchField, page, size]);

  useEffect(() => {
    if (isActive) {
      setSearchField('');
      setSearch('');
      setPage(1);
      setSize(10);
    }
  }, [isActive]);

  const selectedRowKeys: string[] = useMemo(() => {
    if (selectedOrganizations) {
      return selectedOrganizations.map(elem => elem.id);
    }
    return [];
  }, [selectedOrganizations]);

  const rowSelection: TableRowSelection<TOrganizationResponse> = {
    type: 'checkbox',
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: TOrganizationResponse[]) => {
      const orgs = data?.data;

      if (!orgs) {
        return;
      }

      const pickedOrganizations: TOrganizationResponse[] = [];
      let newSelectedOrganizations = [...(selectedOrganizations || [])];

      for (const org of orgs) {
        let isEqual = false;
        for (const selectedUser of selectedRows) {
          if (org.id === selectedUser.id) {
            const userIsPicked = !!newSelectedOrganizations.find(elem => elem.id === org.id);
            //Кидаем новое значение, если оно есть в выбранных на этой странице, но нет в выбранных в общем
            if (!userIsPicked) {
              pickedOrganizations.push(selectedUser);
            }
            isEqual = true;
          }
        }
        // Если массив выбранных не содержит значение из массива с бека, удаляем его из выбранных
        if (!isEqual) {
          newSelectedOrganizations = newSelectedOrganizations.filter(elem => elem.id !== org.id);
        }
      }
      addOrganizations([...pickedOrganizations, ...(newSelectedOrganizations || [])]);
    },
  };

  const handlePagination = (value: number, pageSize: number) => {
    setPage(value);
    setSize(pageSize);
  };

  const onSearchFieldChanged = (data: string) => {
    setSearchField(data);
    setPage(1);
  };

  return (
    <>
      <Spin spinning={isFetching}>
        <Input.Search
          placeholder="Введите название организации"
          value={search}
          onSearch={val => onSearchFieldChanged(val)}
          onChange={e => setSearch(e.target.value)}
          className={style.input}
        />
        <Table
          rowSelection={rowSelection}
          pagination={false}
          columns={columns}
          dataSource={(data?.data && data?.data.map(elem => ({ ...elem, key: elem.id }))) || []}
        />
        <div className={style.pagination}>
          <Pagination
            showSizeChanger
            defaultCurrent={1}
            current={page}
            pageSize={size}
            total={data?.pagination.total}
            onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
          />
        </div>
      </Spin>
    </>
  );
};

export default OrganizationsSearch;
